import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createHead } from '@unhead/vue/client'

/* fontawesome setup */
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faEyeSlash, faHeadset, faCircleDown, faPersonDigging, faMedal, faBriefcase,
  faBuilding, faMap, faChevronLeft, faChevronRight, faAngleRight, faHandshake,
  faPhone, faCode, faFilePdf, faUserSecret, faArrowRight, faEnvelope, faKey,
  faEye, faUser, faAnglesLeft, faAnglesRight, faChessRook, faChessKnight,
  faChess, faGlobe, faBrain, faChessBoard, faShieldHalved, faArrowLeft,
  faFolder, faFolderOpen, faFolderPlus, faCloudArrowUp, faDownload, faTrashCan,
  faUserGroup, faUserLock, faPen, faFile, faFileLines, faXmark, faCheck,
  faMagnifyingGlass, faRightFromBracket, faEllipsisVertical
} from '@fortawesome/free-solid-svg-icons'

library.add(
  faEyeSlash, faHeadset, faCircleDown, faPersonDigging, faMedal, faBriefcase,
  faBuilding, faMap, faChevronLeft, faChevronRight, faAngleRight, faHandshake,
  faPhone, faCode, faFilePdf, faUserSecret, faArrowRight, faEnvelope, faKey,
  faEye, faUser, faAnglesLeft, faAnglesRight, faChessRook, faChessKnight,
  faChess, faGlobe, faBrain, faChessBoard, faShieldHalved, faArrowLeft,
  faFolder, faFolderOpen, faFolderPlus, faCloudArrowUp, faDownload, faTrashCan,
  faUserGroup, faUserLock, faPen, faFile, faFileLines, faXmark, faCheck,
  faMagnifyingGlass, faRightFromBracket, faEllipsisVertical
);

// style général
import "./assets/style.css"
import "./assets/transfer-workspace.css"
import AOS from 'aos';
import 'aos/dist/aos.css';
AOS.init();

// --- Vue App ---
const app = createApp(App)
const head = createHead()

app.use(router)
app.use(head)
app.component('font-awesome-icon', FontAwesomeIcon)

// --- plugin لإرسال render-event بعد mount لكل component ---
app.mixin({
  mounted() {
    if (typeof document !== 'undefined') {
      document.dispatchEvent(new Event('render-event'))
    }
  }
})

// mount بعد router ready
router.isReady().then(() => {
  app.mount('#app')
})
